import { render, staticRenderFns } from "./SecondRoundEnd.vue?vue&type=template&id=0a43ccea&scoped=true"
import script from "./SecondRoundEnd.vue?vue&type=script&lang=js"
export * from "./SecondRoundEnd.vue?vue&type=script&lang=js"
import style0 from "./SecondRoundEnd.vue?vue&type=style&index=0&id=0a43ccea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a43ccea",
  null
  
)

export default component.exports